import React from 'react';
import './style.scss';
import CreamCan from '../../../../../../assets/images/common/creamCan';
import SVGLandingFooterRanksMasterbator from '../../../../../../assets/images/landing/pre_footer/ranks/masterbator';

const LandingFooterRanks = () => (
  <section id='ranks' className='landing-footer-section-ranks'>
    <h2 className='lfsr-wording-wrapper'>ranks</h2>
    <p className='lfsr-text'>
      Pimp your nifty hand, climb up in ranking to unlock bigger battles and
      become the greatest masterbator of all time.
      <br />
      <br />
      Lvl up in battles, earn stars and unlock new ranks.
    </p>
    <div className='lfsr-table-border-wrapper'>
      <div className='lfsr-table-wrapper'>
        <table className='lfsr-table'>
          <thead>
            <tr>
              <th>Lvl/Rank:</th>
              <th>Noob</th>
              <th>Kid</th>
              <th>Pro</th>
              <th>Legend</th>
              <th className='lfsr-masterbator-wrapper'>
                <SVGLandingFooterRanksMasterbator className='lfsr-masterbator' />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='body-2'>⭐</td>
              <td>0</td>
              <td>75</td>
              <td>250</td>
              <td>500</td>
              <td>900</td>
            </tr>
            <tr>
              <td className='body-2'>⭐⭐</td>
              <td>25</td>
              <td>125</td>
              <td>325</td>
              <td>600</td>
              <td>1500</td>
            </tr>
            <tr>
              <td className='body-2'>⭐⭐⭐</td>
              <td>50</td>
              <td>175</td>
              <td>400</td>
              <td>700</td>
              <td>3000</td>
            </tr>
            <tr>
              <td className='caption-xs'>Wager Allowance</td>
              <CreamSell amount={10} />
              <CreamSell amount={25} />
              <CreamSell amount={100} />
              <CreamSell amount={500} />
              <CreamSell amount={2500} />
            </tr>
            <tr>
              <td className='caption-xs'>Number of hands in battles</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>5</td>
              <td>5</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

const CreamSell = ({ amount }) => (
  <td>
    <div className='lfsr-cream-cell'>
      {amount}
      <CreamCan className='lfsr-cream-can' />
    </div>
  </td>
);

export default LandingFooterRanks;
